<template>
  <div class='passwd-warp'>
    <div class="passwd">
      <div class="close">
        <i class="el-icon-close" @click='close'></i>
      </div>
      <div class="title">修改密码</div>
      <div class="tabs">
        <el-radio-group v-model.trim="way">
          <el-radio-button :label="1">原密码方式</el-radio-button>
          <el-radio-button :label="2">手机验证方式</el-radio-button>
        </el-radio-group>
      </div>
      <div class="from">
        <el-form :model="ruleForm" :label-width="`${Scaling(120)}px`" :rules="rules" ref="rules">
          <el-form-item label="原密码" v-if="way === 1" prop="oldPassword">
            <el-input type="password" v-model.trim="ruleForm.oldPassword"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" v-if="way === 2">{{phone}}</el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input type="password" v-model.trim="ruleForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="重复新密码" prop="newPasswordAgain">
            <el-input type="password" v-model.trim="ruleForm.newPasswordAgain"></el-input>
          </el-form-item>
          <el-form-item label="验证码" v-if="way === 2" prop="code">
            <div class="verification">
              <el-input type="text" v-model.trim="ruleForm.code"></el-input>
              <el-button class="verification-btn" round type="primary" :disabled='disabled' @click="verBtn">{{verName}}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn">
        <el-button type="primary" @click="submitForm()">提交</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/apps'
export default {
  name: 'passwd',

  data () {
    return {
      way: 1,
      disabled: false,
      phone: JSON.parse(sessionStorage.getItem('User')).phone,
      verName: '获取验证码',
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: '',
        code: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'change' }
        ],
        newPasswordAgain: [
          { required: true, message: '请输入新密码', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ]
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {},

    verBtn () {
      if (this.phone) {
        const params = {
          method: api.code
        }
        this.axios.post(params).then(res => {
          if (res.data.backend_org_ums_change_password_get_code_response.code !== '10000') return
          this.showBtn()
        })
      } else {
        this.$message({
          message: '该账户暂无绑定手机',
          type: 'warning'
        })
      }
    },

    showBtn () {
      this.disabled = true
      let index = 60
      const timer = setInterval(res => {
        index--
        this.verName = `获取验证码(${index})`
        if (index <= 0) {
          clearInterval(timer)
          this.disabled = false
          this.verName = '获取验证码'
        }
      }, 1000)
    },

    resetForm () {
      this.ruleForm.oldPassword = ''
      this.ruleForm.newPassword = ''
      this.ruleForm.newPasswordAgain = ''
      this.ruleForm.code = ''
    },

    close () {
      this.$emit('close')
    },

    submitForm () {
      this.$refs.rules.validate((valid) => {
        if (valid) {
          this.ajax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    ajax () {
      let params
      if (this.way === 1) {
        params = {
          method: api.password,
          oldPassword: this.ruleForm.oldPassword,
          newPassword: this.ruleForm.newPassword,
          newPasswordAgain: this.ruleForm.newPasswordAgain
        }
      } else {
        params = {
          method: api.password,
          code: this.ruleForm.code,
          newPassword: this.ruleForm.newPassword,
          newPasswordAgain: this.ruleForm.newPasswordAgain
        }
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_org_ums_change_password_response.code !== '10000') return
        this.$message({
          message: '密码修改成功，请重新登录',
          type: 'success'
        })
        this.close()
        this.$router.push({ name: 'AUTH' })
        sessionStorage.clear()
      })
    },

    // 自适应缩放
    Scaling (val) {
      if (document.querySelector('html').offsetWidth <= 1280) {
        return 1280 / 1920 * val
      } else {
        return document.querySelector('html').offsetWidth / 1920 * val
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
  .passwd-warp
    position fixed
    width 100%
    height 100%
    left 0
    top 0
    background rgba(0, 0, 0, .3)
    z-index 3
    .passwd
      width 500px
      padding 20px 40px 20px 20px
      border-radius 20px
      position absolute
      top 50%
      left 50%
      background #ffffff
      transform translate(-50%, -50%)
      display flex
      flex-direction column
      .close
        text-align right
        margin-right -20px
        i
          font-size 20px
          &:hover
            color #f56c6c
            cursor pointer
      .title
        text-align center
        font-size 24px
        font-weight bold
        margin-top -20px
      .tabs
        width 100%
        text-align center
        margin-top 20px
      .from
        margin-top 20px
        .verification
          display flex
          .verification-btn
            margin-left 20px
      .btn
        text-align center
        margin-right -10px
</style>
